import { Layout } from 'antd';
import React from 'react';
import { getEnv } from '../environment/resolve';
const AppFooter = () => {
  const [release, setRelease] = React.useState('');
  React.useEffect(() => {
    setRelease(window.__BUILD_INFO__?.release || '');
  }, []);
  return <Layout.Footer data-sentry-element="unknown" data-sentry-component="AppFooter" data-sentry-source-file="AppFooter.jsx">
        <div className="landing-footer-container no-print">
          <div className="landing-footer landing-footer-left">
            <p>
              Need Help? <br />
              Contact Support:{' '}
              <a href="mailto:support@footsteps2Brilliance.com">
                support@footsteps2Brilliance.com
              </a>
            </p>
          </div>
          <div className="landing-footer landing-footer-right">
            <ul className='footer-link-list'>
            {getEnv().footerLinks.map(({
            href,
            title
          }) => <li key={href}>
                  <a href={href}>{title}</a>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="copyright">
          &copy;{new Date().getFullYear()}, Footsteps2Brilliance, Inc. <span className="build-number">({release})</span>
        </div>
      </Layout.Footer>;
};
export default AppFooter;